"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.OptionsShell = void 0;
var framer_motion_1 = require("framer-motion");
var react_1 = __importStar(require("react"));
var themes_1 = require("../../../../themes");
var mixins_1 = require("../../../../themes/mixins");
var useScreenWidth_1 = require("../../../../utils/customHooks/useScreenWidth");
var usePopOutOfOverflowHiddenParent_1 = require("../../../../utils/usePopOutOfOverflowHiddenParent");
var Buttons_1 = require("../../../Buttons");
var Modal_1 = require("../../../Modals/Modal");
var styled_1 = require("./styled");
var OptionsAnimateWrapper_1 = require("./comps/OptionsAnimateWrapper");
var styled_components_1 = require("styled-components");
var DefaultMobileShell = function (_a) {
    var children = _a.children;
    return (react_1.default.createElement("div", { style: { top: 0, left: 0, height: '100dvh', width: '100dvw', position: 'fixed', zIndex: '100000000', background: 'rgba(0,0,0,0.5)', display: 'flex', flexDirection: 'column', justifyContent: 'flex-end' } }, children));
};
exports.OptionsShell = react_1.default.forwardRef(function (_a, ref) {
    var yOrientation = _a.yOrientation, lightboxHeight = _a.lightboxHeight, lightboxStyle = _a.lightboxStyle, options = _a.options, optionsAnchor = _a.optionsAnchor, showOptions = _a.showOptions, handleHideOptions = _a.handleHideOptions, children = _a.children, SelectComp = _a.SelectComp, label = _a.label, optionsModalLabel = _a.optionsModalLabel, invert = _a.invert, showDoneButton = _a.showDoneButton, _b = _a.popOutOfOverflowHiddenParent, popOutOfOverflowHiddenParent = _b === void 0 ? false : _b, relativeToRef = _a.relativeToRef, S = _a.S, alignDropdown = _a.alignDropdown;
    var screenWidth = (0, useScreenWidth_1.useScreenWidth)();
    var isDesktop = screenWidth >= (0, mixins_1.getBreakPoint)("sm");
    var currentTheme = (0, styled_components_1.useTheme)();
    var MobileShell = (currentTheme === null || currentTheme === void 0 ? void 0 : currentTheme.MobileShell) || DefaultMobileShell;
    var _c = (0, usePopOutOfOverflowHiddenParent_1.usePopOutOfOverflowHiddenParent)(popOutOfOverflowHiddenParent), fixPos = _c.fixPos, applyFixedPos = _c.applyFixedPos, removeFixedPos = _c.removeFixedPos, trackerRef = _c.trackerRef;
    (0, react_1.useEffect)(function () {
        if (popOutOfOverflowHiddenParent) {
            if (showOptions)
                applyFixedPos();
            else
                removeFixedPos();
        }
    }, [showOptions]);
    return isDesktop ? (react_1.default.createElement(react_1.Fragment, null,
        popOutOfOverflowHiddenParent && react_1.default.createElement("div", { ref: trackerRef }),
        react_1.default.createElement(OptionsAnimateWrapper_1.OptionsAnimateWrapper, { options: options, optionsRef: ref, relativeToRef: relativeToRef, showOptions: showOptions, invert: invert, yOrientation: yOrientation, fixPos: fixPos, optionsAnchor: optionsAnchor, children: children, lightboxStyle: lightboxStyle, alignDropdown: alignDropdown },
            react_1.default.createElement(styled_1.StyledOptionsWrapper, { id: "StyledOptionsWrapper", ref: ref, invert: invert, lightboxHeight: lightboxHeight, 
                // className={className}
                style: {
                    position: "absolute",
                    bottom: yOrientation === "top" ? undefined : 0,
                    top: yOrientation === "top" ? 0 : undefined,
                } }, children)))) : (
    // <AnimatePresence>
    //   {showOptions ? (
    //     <Modal
    //       fitToContentHeight
    //       title={optionsModalLabel || label}
    //       onClose={handleHideOptions}
    //       invert={invert}
    //       S={S}
    //       dynamicHeaderHeight
    //     >
    react_1.default.createElement(react_1.Fragment, null, showOptions ? (react_1.default.createElement(MobileShell, { onClose: handleHideOptions, title: optionsModalLabel || label },
        SelectComp && SelectComp,
        react_1.default.createElement(styled_1.StyledModalOptionsWrapper, { invert: invert, ref: ref }, children),
        showDoneButton && (react_1.default.createElement("div", { style: {
                backgroundColor: invert ? themes_1.colors.greyColor90 : themes_1.colors.white,
                padding: "1rem 2rem",
                position: "sticky",
                bottom: "0",
            } },
            react_1.default.createElement(Buttons_1.ButtonPrimary, { children: "Done", width: "100%", onClick: handleHideOptions, S: S }))))) : null)
    //     </Modal>
    //   ) : null}
    // </AnimatePresence>
    );
});
